import { createFileRoute } from '@tanstack/react-router';
import { trpc } from '@/lib/trpc';
import { SignContractPage } from './-components/contracts/sign-contract-page';

export const Route = createFileRoute('/ngos/contracts/$contractId/sign')({
	loader: ({ context, params }) => {
		context.queryClient.prefetchQuery(trpc.contract.signingView.queryOptions({ contractId: params.contractId }));
	},
	component: SignContractRoute,
});

function SignContractRoute() {
	const { contractId } = Route.useParams();

	return <SignContractPage contractId={contractId} />;
}
